import React from "react";
import "./VolunteerGroup.css";

interface VolunteerGroup {
    id?: number;
    name: string;
    type: string;
    eventId: number;
    event?: {
        eventID: number;
        eventName: string;
    };
    function?: string;
    maxSlots: number;
    contactPersonId?: number;
    contactPerson?: {
        id: number;
        firstName: string;
        lastName: string;
    };
    selfAssignShifts: boolean;
    deadline?: string;
}

interface Props {
    groups: VolunteerGroup[];
    persons: any[];
    onEdit: (group: VolunteerGroup) => void;
    onDelete: (id?: number) => void;
}

const VolunteerGroupList: React.FC<Props> = ({
    groups,
    persons,
    onEdit,
    onDelete,
}) => {

    const getAssignedCount = (group: VolunteerGroup) => {
        if (!group.contactPersonId) return 0;

        const normalize = (s: any) =>
            (s ?? "")
                .toString()
                .replace(/\s+/g, " ")
                .trim()
                .toLowerCase();

        const contact = persons.find(
            p => p.personId === group.contactPersonId
        );

        if (!contact) return 0;

        const matchedPersons = persons.filter(p =>
            p.userId === contact.userId &&
            normalize(p.firstName) === normalize(group.name)
        );
        return matchedPersons.length;
    };

    return (
        <div>
            <h2>Frivilliggrupper</h2>

            <table className="persons-table">
                <thead>
                    <tr>
                        <th>Navn</th>
                        <th>Type</th>
                        <th>Event</th>
                        <th>Funktion</th>
                        <th>Pladser</th>
                        <th>Tildelt</th>
                        <th>Selvtilmelding</th>
                        <th>Deadline</th>
                        <th>Kontaktperson</th>
                        <th>Handlinger</th>
                    </tr>
                </thead>

                <tbody>
                    {groups.map((g) => (
                        <tr key={g.id}>
                            <td>{g.name}</td>
                            <td>{g.type}</td>
                            <td>{g.event?.eventName ?? "-"}</td>
                            <td>{g.function || "-"}</td>
                            <td>{g.maxSlots}</td>

                            <td>
                                {g.maxSlots - getAssignedCount(g)} / {g.maxSlots}
                            </td>

                            <td>{g.selfAssignShifts ? "Ja" : "Nej"}</td>

                            <td>
                                {g.deadline
                                    ? new Date(g.deadline).toLocaleDateString("da-DK")
                                    : "-"}
                            </td>

                            <td>
                                {g.contactPerson
                                    ? `${g.contactPerson.firstName} ${g.contactPerson.lastName}`
                                    : "-"}
                            </td>

                            <td>
                                <button
                                    className="edit-btn"
                                    onClick={() => onEdit(g)}
                                >
                                    Rediger
                                </button>

                                <button
                                    className="delete-btn"
                                    onClick={() => onDelete(g.id)}
                                >
                                    Slet
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default VolunteerGroupList;